'use strict';

angular.module('shiftTraderApp')
  .factory('UsersPositions', function ($http, ServerUrls, $q) {

    var UsersPosition = function(initData) {
      var up = {}
      angular.extend(up, initData);

      up.$setInactive = function () {
        var payload = {
          id: up.id,
          active: false
        }
        return UsersPositions.update(payload)
          .then(function (updatedUp) {
            up.active = updatedUp.active
            return updatedUp
          }, function (response) {
            $q.reject(response)
          })
      }

      return up
    }

    var UsersPositions = {};

    UsersPositions.initWithData = function (initData) {
      return new UsersPosition(initData)
    }


    UsersPositions.getAll = function(params) {
      var config = {
        params: _.extend({}, params)
      };

      return $http.get(ServerUrls.current.railsApi + 'users_positions/', config)
        .then(function(response) {
          return lodash.map(response.data, function (up) {
            return new UsersPosition(up)
          });
        }, function(response) {
          return $q.reject(response);
        });
    };

    UsersPositions.create = function(data) {
      return $http.post(ServerUrls.current.railsApi + 'users_positions/', data)
        .then(function(response) {
          return new UsersPosition(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };
// 
      // IE8 doesn't like anything with a property name of 'delete'
    // UsersPositions['delete'] = function(id) {
    //   // IE8 doesn't like $http.delete name
    //   return $http['delete'](ServerUrls.current.railsApi + 'users_positions/' + id)
    //     .then(function(response) {
    //       //console.log('users_positions deleted');
    //       //console.log(response);
    //       return response.data;
    //     }, function(response) {
    //       return $q.reject(response);
    //     });
    // };

    UsersPositions.update = function(data) {
      return $http.put(ServerUrls.current.railsApi + 'users_positions/' + data.id + '.json', data)
        .then(function(response) {
          return new UsersPosition(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    // Public API here
    return UsersPositions;
  });
